import React from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Store from "@material-ui/icons/Store"; 
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility"; 
// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js"; 
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardIcon from "../../views/Card/CardIcon.js";
import CardBody from "../../views/Card/CardBody.js";
import CardFooter from "../../views/Card/CardFooter.js";
 
// import {
//   dailySalesChart,
//   emailsSubscriptionChart,
//   completedTasksChart
// } from "../../config/charts.js";

import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import axios from "axios";
import moment from 'moment'

import { makeScatterData } from "./data.js";

const useStyles = makeStyles(styles);

const Dashboard = () => {
  const classes = useStyles();
  const [data,setData] = React.useState(false);

  React.useEffect(() => {
    axios({
      method: "post",
      url: "/getDashboardDetails",
    }).then(res => {
      setData(res.data)
      
    }).catch(err => {
      console.log(err)
    })
  },[])
 
  let weeklyOrders = {Mo: 0,Tu: 0,We: 0,Th: 0,Fr: 0,Sa: 0,Su: 0}
  let totalAmount = {Mo: 0,Tu: 0,We: 0,Th: 0,Fr: 0,Sa: 0,Su: 0}
  let partsCount = {Mo: 0,Tu: 0,We: 0,Th: 0,Fr: 0,Sa: 0,Su: 0}

  data && data.oneWeekOrder.forEach(val => {
    let date = moment(val.createdDate);
    let day = date.format("dddd")
    if(day != "Invalid date") {
      weeklyOrders[day.substring(0,2)] += 1;
    }
  })

  data && data.oneWeekOrder.forEach(val => {
    let date = moment(val.createdDate);
    let day = date.format("dddd")
    if(day != "Invalid date") { 
      partsCount[day.substring(0,2)] += val.allLoad.length;
    }
  }) 
  
  data && data.oneWeekSales.forEach(val => {
    let date = moment(val.createdDate);
    let day = date.format("dddd")
    if(day != "Invalid date") { 
      val.allLoad.forEach(item => {
        let total = item.price * item.quantity
        let discountedAmt = total - ((total/100) * item.discount)
        totalAmount[day.substring(0,2)] += total + ((discountedAmt/100)*item.tax ? item.tax.gst : 0)
      })
    }
  }) 

  const weeklyOrdersData = makeScatterData(weeklyOrders,false);
  const totalAmountData = makeScatterData(totalAmount,true);
  const partsCountData = makeScatterData(partsCount,false);
  return (
    <div>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader>
            <div>
              <h3>Dashboard</h3>  
            </div>
          </CardHeader>
        </Card>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Total Orders</p>
              <h3 className={classes.cardTitle}>
                {data && data.totalOrder}
              </h3>
            </CardHeader> 
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Revenue</p>
              <h3 className={classes.cardTitle}>₹ {data && data.oneWeekRevenue}</h3>
            </CardHeader> 
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Icon>info_outline</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Completed Order</p>
              <h3 className={classes.cardTitle}>{data && data.completedOrder.length}</h3>
            </CardHeader> 
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Users</p>
              <h3 className={classes.cardTitle}>{data && data.userCount}</h3>
            </CardHeader> 
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={weeklyOrdersData.data}
                type="Line"
                options={weeklyOrdersData.options}
                listener={weeklyOrdersData.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Orders</h4> 
            </CardBody> 
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={totalAmountData.data}
                type="Bar"
                options={totalAmountData.options}
                responsiveOptions={totalAmountData.responsiveOptions}
                listener={totalAmountData.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Order Total Amount</h4>
            </CardBody> 
          </Card>
        </GridItem>
  
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="info">
              <ChartistGraph
                className="ct-chart"
                data={partsCountData.data}
                type="Line"
                options={partsCountData.options}
                listener={partsCountData.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Parts Count</h4> 
            </CardBody> 
          </Card>
        </GridItem>  
      </GridContainer> 
    </div>
  );
}

export default Dashboard;